import type { ReactElement } from "react";
import { Box, Center, Image as ChakraImage, Icon } from "@chakra-ui/react";
import EntityIcons from "components/icons/entity-icons";
import colorSchemes from "data/color-schemes";

interface LogoOrFallbackProps {
  logo?: string;
  name: string;
}

const LogoOrFallback = ({ logo, name }: LogoOrFallbackProps): ReactElement => {
  if (logo) {
    return (
      <Box
        h={6}
        w={6}
        rounded="md"
        bg="white"
        position="relative"
        overflow="hidden"
        mr={2}
        flexShrink={0}
      >
        <ChakraImage src={logo} objectFit="fill" alt={`${name} Logo`} />
      </Box>
    );
  }

  return (
    <Center
      h={6}
      w={6}
      rounded="md"
      bg={`${colorSchemes.company}.50`}
      mr={2}
      border="1px solid"
      borderColor={`${colorSchemes.company}.100`}
      flexShrink={0}
    >
      <Icon
        as={EntityIcons.company}
        h={5}
        w={5}
        color={`${colorSchemes.company}.500`}
      />
    </Center>
  );
};

export default LogoOrFallback;
